var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tabs-content',{staticClass:"system-equipment"},[_c('pi-dev-statistics',{attrs:{"initData":_vm.initData}}),_c('pi-dev-table',{attrs:{"initData":_vm.initData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }